import React from 'react'

import { ContentProps } from '../../renderer'
import { TypeItemTrustedBy } from '../../../lib/types'
import { ImageAsset } from '../../asset/image'
import styles from './trusted-by.module.scss'
import cn from 'classnames'

type Extra = {
  isScrollable?: boolean
  disableResponsive?: boolean
}

export const TrustedByItem: React.FC<ContentProps<TypeItemTrustedBy> & Extra> = (props) => {
  const {
    structure: {
      fields: { image, companyName },
    },
    isScrollable,
    disableResponsive,
  } = props

  if (!image) {
    return null
  }

  const imageStructure = { ...image, fields: { ...image.fields, title: companyName } }

  return (
    <ImageAsset
      className={cn(styles.imgContainer, {
        [styles.scrollingLogos]: isScrollable,
        [styles.responsive]: !disableResponsive,
      })}
      structure={imageStructure}
    />
  )
}
